import { render, staticRenderFns } from "./PendingMtr.vue?vue&type=template&id=71ac0c98&scoped=true&"
import script from "./PendingMtr.vue?vue&type=script&lang=js&"
export * from "./PendingMtr.vue?vue&type=script&lang=js&"
import style0 from "./PendingMtr.vue?vue&type=style&index=0&id=71ac0c98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ac0c98",
  null
  
)

component.options.__file = "PendingMtr.vue"
export default component.exports